module.exports = __webpack_public_path__ + "img/RETURN_SALE.95551ed8.svg";